import axios from './axios.js'

// 砍价订单接口
export function getOrderList(data) {
    return axios.post('/order_mall_cut/list_data', data)
}

// 砍价成员
export function getMembersList(data) {
    return axios.post('/order_mall_cut/list_joiner_data', data)
}

// 兑换订单列表
export function exchangeList(data) {
    return axios.post('/order_lottery/page', data)
}

// 财务订单流水接口
export function financialList(limit, page) {
    return axios.get(`/finance_order/list_data?limit=${limit}&page=${page}`)
}

// 秒杀订单接口
export function miaoshaList(data) {
    return axios.post('/order_mall/list_data_spike', data)
}

// 提现审核列表数据
export function withdrawalList(limit, page) {
    return axios.get(`/finance_clear/list_data?limit=${limit}&page=${page}`)
}
// 提现审核列详情数据
export function withdrawaDetailslList(objId) {
    return axios.get(`/finance_clear/withdrawal_details?objId=${objId}`)
}

// 订单收入列表数据
export function orderIncomeList(limit, page, orderNo) {
    return axios.get(`/finance_order/list_data?limit=${limit}&page=${page}`)
}

// 订单收入财务详情
export function orderIncomeListDetails(limit, page, orderNo) {
    return axios.get(`/finance_order/list_data?limit=${limit}&orderNo=${orderNo}&page=${page}`)
}


// WEBPACK FOOTER //
// ./src/api/orderApi.js